<template>
  <v-overlay absolute :value="value || loading">
    <div class="d-flex flex-column align-center">
      <v-progress-circular
        indeterminate
        :size="70" :width="7"
        color="primary"
        v-if="loading"
      ></v-progress-circular>
      <template v-else >
        <v-dialog
          value="value"
          max-width="290"
          persistent
        >
          <v-card class="pb-4">
            <v-card-title class="text-h6 error">
              {{ title }}
            </v-card-title>

            <v-divider />

            <v-card-text class="mt-4 text-body-1 text-center">
              {{ message }}
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn width="60%" @click="close">Back</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </v-overlay>
</template>

<script>

export default {
  name:  'ErrorOverlay',

  props: ['loading', 'message', 'title', 'value'],

  methods: {
    close() {
      this.$emit('input', false)
    },
  },
}

</script>
